var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestionFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#330072"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25062 5.02266C7.87834 4.95881 7.49548 5.02876 7.16983 5.22015C6.84419 5.41153 6.59679 5.71198 6.47145 6.0683C6.37985 6.3287 6.09449 6.46553 5.83409 6.37393C5.57369 6.28233 5.43686 5.99698 5.52846 5.73658C5.73214 5.15757 6.13417 4.66933 6.66334 4.35833C7.19251 4.04733 7.81466 3.93365 8.41962 4.03742C9.02457 4.14118 9.57328 4.4557 9.96857 4.92526C10.3638 5.39475 10.5801 5.98894 10.5793 6.60263C10.5791 7.56746 9.862 8.22254 9.30709 8.59248C9.01438 8.78762 8.72523 8.93184 8.51123 9.02695C8.40352 9.07482 8.31306 9.11104 8.24836 9.13568C8.21597 9.14802 8.18992 9.15751 8.17125 9.16415L8.14887 9.17198L8.14206 9.17431L8.13978 9.17508L7.98023 8.70141L8.13828 9.17558C7.87641 9.26287 7.59335 9.12134 7.50606 8.85947C7.41885 8.59784 7.56003 8.31507 7.82144 8.22749L7.82363 8.22674L7.83636 8.22228C7.84844 8.21798 7.86749 8.21107 7.8925 8.20154C7.9426 8.18245 8.01615 8.15307 8.10524 8.11347C8.28484 8.03365 8.5205 7.91546 8.75259 7.76073C9.24721 7.43099 9.57964 7.03659 9.57964 6.60218C9.5802 6.22446 9.44707 5.85799 9.20382 5.56903C8.96057 5.28007 8.6229 5.08652 8.25062 5.02266Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5365 11.5002C7.5365 11.2241 7.76028 11.0004 8.03632 11.0004H8.04331C8.31936 11.0004 8.54313 11.2241 8.54313 11.5002C8.54313 11.7762 8.31936 12 8.04331 12H8.03632C7.76028 12 7.5365 11.7762 7.5365 11.5002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionFilled);
export default __webpack_public_path__ + "static/media/iconQuestionFilled.c6f01da9bb76620ff0d41423e9c28e67.svg";
export { ForwardRef as ReactComponent };